import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionEyebrow } from "./SectionEyebrow";
import { FUNDER_SECTIONS } from "../../lib/funderFaq";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const pick = (sectionId, index = 0) =>
  FUNDER_SECTIONS.find((s) => s.id === sectionId)?.faqs[index];

const TEASER_FAQS = [
  pick("funder-general", 3),  // How does Clinq vet businesses?
  pick("funder-general", 4),  // What is the Capital Readiness Score?
  pick("funder-general", 8),  // What criteria can I set to filter deal flow?
  pick("funder-general", 5),  // How does Clinq handle introductions?
].filter(Boolean);

export const FunderFAQTeaser = () => (
  <section data-testid="funder-faq-teaser" className="bg-[#F4F8F8] text-neutral-900">
    <div className="mx-auto max-w-4xl px-6 py-20 lg:py-28">
      <SectionEyebrow testid="funder-faq-eyebrow">Questions, answered</SectionEyebrow>
      <h2 className="mt-4 text-3xl font-extrabold tracking-tight sm:text-4xl"
        style={{ fontFamily: "Manrope, sans-serif" }}>
        Funder <span className="text-[#0A8B85]">FAQs</span>
      </h2>
      <p className="mt-4 max-w-xl text-base leading-relaxed text-neutral-600">
        The four things funders ask us most before joining the platform.
      </p>

      <Accordion type="single" collapsible className="mt-8">
        {TEASER_FAQS.map((f, i) => (
          <AccordionItem key={i} value={`funder-teaser-${i}`}
            data-testid={`funder-faq-teaser-item-${i}`}
            className="border-neutral-200">
            <AccordionTrigger className="text-left text-[15px] font-bold text-neutral-800 hover:text-[#0A8B85] hover:no-underline sm:text-base">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[15px] leading-relaxed text-neutral-700">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <Link to="/faq?for=funders" data-testid="funder-faq-see-all"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0A8B85] px-6 py-3 text-sm font-bold text-white transition-opacity hover:opacity-90">
        See all funder FAQs <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  </section>
);
